module.exports = __webpack_public_path__ + "img/dowar.f044d31.png";